import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { MenuList, MenuItem, ListItemIcon, Typography, Chip } from "@mui/material";
import { DesignServicesRounded, VisibilityRounded } from "@mui/icons-material";
import { AppState } from "../../../../../shell/store/types";
import { ContentItem } from "../../../../../shell/services/types";
import { useGetDomainsQuery } from "../../../../../shell/services/accounts";
import { ApiType } from "../../../../schema/src/app/components/ModelApi";
type APIEndpointsProps = {
  type: Extract<ApiType, "quick-access" | "site-generators">;
};
export const APIEndpoints = ({
  type
}: APIEndpointsProps) => {
  const {
    t
  } = useTranslation();
  const {
    modelZUID,
    itemZUID
  } = useParams<{
    modelZUID: string;
    itemZUID: string;
  }>();
  const item = useSelector((state: AppState) => state.content[itemZUID] as ContentItem);
  const instance = useSelector((state: AppState) => state.instance);
  const {
    data: domains
  } = useGetDomainsQuery();
  const apiTypeEndpointMap: Partial<Record<ApiType, string>> = {
    "quick-access": `/-/instant/${itemZUID || modelZUID}.json`,
    "site-generators": item ? `/${item?.web?.path}/?toJSON` : "/?toJSON"
  };
  const liveDomain = domains?.find(domain => domain.branch == "live");
  return <MenuList data-sentry-element="MenuList" data-sentry-component="APIEndpoints" data-sentry-source-file="APIEndpoints.tsx">
      <MenuItem onClick={() => {
      window.open(`${CONFIG.URL_PREVIEW_PROTOCOL}${instance.randomHashID}${CONFIG.URL_PREVIEW}${apiTypeEndpointMap[type]}`, "_blank");
    }} data-sentry-element="MenuItem" data-sentry-source-file="APIEndpoints.tsx">
        <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="APIEndpoints.tsx">
          <DesignServicesRounded data-sentry-element="DesignServicesRounded" data-sentry-source-file="APIEndpoints.tsx" />
        </ListItemIcon>
        <Typography variant="inherit" noWrap sx={{
        width: 172
      }} data-sentry-element="Typography" data-sentry-source-file="APIEndpoints.tsx">
          {`${instance.randomHashID}${CONFIG.URL_PREVIEW}${apiTypeEndpointMap[type]}`}
        </Typography>
        <Chip size="small" label={t("common.dev")} data-sentry-element="Chip" data-sentry-source-file="APIEndpoints.tsx" />
      </MenuItem>
      {liveDomain && <MenuItem onClick={() => {
      window.open(`https://${liveDomain.domain}${apiTypeEndpointMap[type]}`, "_blank");
    }}>
          <ListItemIcon>
            <VisibilityRounded />
          </ListItemIcon>
          <Typography variant="inherit" noWrap sx={{
        width: 172
      }}>
            {`${liveDomain.domain}${apiTypeEndpointMap[type]}`}
          </Typography>
          <Chip size="small" label={t("common.prod")} />
        </MenuItem>}
    </MenuList>;
};